// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';
import { navLinkBaseCss } from '@zapier/platform/src/constants';

import type { HeaderNavLink } from '@zapier/platform/src/types';

/** @jsx jsx */

const mainNavLinkCss = ({ isActive }) => ({
  color: Colors.batmobile,
  textDecoration: 'none',
  position: 'relative',
  whiteSpace: 'nowrap',
  '@media (min-width: 1079px)': {
    ...navLinkBaseCss,
    ...(isActive
      ? {
          ...navLinkBaseCss['&:hover'],
          ':before': {
            content: "''",
            position: 'absolute',
            left: 0,
            bottom: -6,
            width: '100%',
            height: 2,
            backgroundColor: Colors.white,
          },
        }
      : {}),
  },
});

const exitIconCss = {
  display: 'inline-block',
  padding: '0 1ch',
  position: 'relative',
  top: '-0.25em',
  ':before': {
    content: '""',
    display: 'inline-block',
    width: 1,
    height: 1,
    border: `solid 5px transparent`,
    borderBottomColor: Colors.lava,
    verticalAlign: 'top',
    transform: 'rotate(45deg)',
  },
};

const NavLink = ({ href, label, isActive, isExit }: HeaderNavLink) => (
  <a css={mainNavLinkCss({ isActive })} href={href}>
    {label}
    {isExit && <span css={exitIconCss} />}
  </a>
);

export default NavLink;
